document.addEventListener('DOMContentLoaded', function() {

	/**
	 * Correct max height 
	 * 
	 * */
	correct_max_height();


	/**
	 * Open/ close accordion 
	 * 
	 * */
	document.querySelectorAll('.accordion__container').forEach(function(accordion) {
		accordion.addEventListener('click', function(event) {
			const header = event.target.closest('.accordian__header');
			
			if (!header) return;

			const block = header.closest('.accordian__block');
			if (!block.classList.contains('open')) {
				document.querySelectorAll('.accordian__block.open').forEach(function(openBlock) {
					openBlock.classList.remove('open');
				});
				block.classList.add('open');

				setTimeout(function() {
					let scroll_to = header.getBoundingClientRect().top + window.pageYOffset;
					const nav = document.querySelector('.nav');
					if (nav) scroll_to -= nav.offsetHeight;
					if (document.body.classList.contains('admin-bar')) {
						const adminBar = document.getElementById('wpadminbar');
						if (adminBar) scroll_to -= adminBar.offsetHeight;
					}
					window.scrollTo({ top: scroll_to, behavior: 'smooth' });
				}, 1000);
			} else {
				block.classList.remove('open');
			}
		});
	});

});

window.addEventListener('resize', function(event) {
	correct_max_height();
});

function correct_max_height() {
	document.querySelectorAll('.accordian__block').forEach(function(el) {
		const header = el.querySelector('.accordian__header');
		const body = el.querySelector('.accordian__body');
		if (!header || !body) return;

		let max_h = header.scrollHeight + body.scrollHeight;

		const firstChild = body.children[0];
		if (firstChild) {
			max_h += parseInt(getComputedStyle(firstChild).marginTop) || 0;
			max_h += parseInt(getComputedStyle(firstChild).paddingTop) || 0;
		}

		const lastChild = body.children[body.children.length - 1];
		if (lastChild) {
			max_h += parseInt(getComputedStyle(lastChild).marginBottom) || 0;
			max_h += parseInt(getComputedStyle(lastChild).paddingBottom) || 0;
		}

		max_h *= 1.25; // safe margin

		el.style.setProperty('--max-h', max_h + 'px');
	});
}